import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      websocket: null,
  },
  mutations: {
      SET_WEBSOCKET: (state, websocket) => {
          state.websocket = websocket
      },
  },
  actions: {
      setWebsocket({ commit }, websocket){
          commit('SET_WEBSOCKET', websocket);
          return
      }
  },
  modules: {
      user
  },
})
